import * as types from '../constants'
import { Record, Map } from 'immutable'

const similarPropertiesRecord = Record({
  data: Map(),
})

const initialState = new similarPropertiesRecord()

export default (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_SIMILAR_PROPERTIES: {
      const newState = state.merge({
        data: state.data.merge(Map(action.data)),
      })
      return newState
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/similarProperties.js